import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { Divider as BaseDivider } from '@xing-com/divider';
import { IconAIFilled } from '@xing-com/icons';
import { mediaTopBarHidden, mediaTopBarVisible } from '@xing-com/layout-tokens';
import {
  scale090,
  scale180,
  spaceL,
  spaceXL,
  xdlColorButtonStrong,
  xdlColorButtonStrongHover,
  xdlColorTextInvert,
  xdlColorTextOnDark,
  xdlPaletteGrayPlain11,
  spaceM,
  spaceS,
  scale130,
  scale110,
  spaceXXL,
} from '@xing-com/tokens';
import { Hero } from '@xing-com/typography';

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 800px;

  @media ${mediaTopBarHidden} {
    max-width: 648px;
  }
`;

export const Title = styled(Hero)`
  margin-bottom: ${spaceXXL};
  text-wrap: balance;

  @media ${mediaTopBarVisible} {
    margin-inline: 20px;
  }

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const Icon = styled(IconAIFilled)`
  transform: translateY(-${spaceS});
  height: ${scale110};

  @media ${mediaTopBarHidden} {
    height: ${scale130};
  }
`;

export const Form = styled.form`
  padding-left: 20px;
  padding-right: 20px;
  display: grid;
  grid-template-columns: auto;
  grid-template-areas:
    'key'
    'div'
    'loc';

  @media ${mediaTopBarHidden} {
    padding-left: 0;
    padding-right: 0;
    gap: ${spaceL};
    grid-template-columns: 1fr auto;
    grid-template-areas:
      'key key'
      'loc but';
  }
`;

export const Divider = styled(BaseDivider)`
  grid-area: div;

  @media ${mediaTopBarHidden} {
    display: none;
  }
`;

export const LocationFieldsWrapper = styled.div`
  grid-area: loc;
  display: flex;
  position: relative;
`;

const SubmitButton = styled(Button)`
  grid-area: but;
  color: ${xdlColorTextInvert};
  flex-shrink: 0;

  &::after {
    background-color: ${xdlColorButtonStrong};
  }

  &:hover::after {
    background-color: ${xdlColorButtonStrongHover};
  }

  &:active {
    color: ${xdlColorTextOnDark};

    &::after {
      background-color: ${xdlPaletteGrayPlain11};
    }
  }
`;

export const SubmitButtonBig = styled(SubmitButton)`
  display: none;

  @media ${mediaTopBarHidden} {
    display: block;
    height: ${scale180};
    font-size: ${scale090};
    padding-inline: ${spaceXL};
  }
`;

export const SubmitButtonSmall = styled(SubmitButton)`
  position: absolute;
  right: ${spaceM};
  top: ${spaceS};

  @media ${mediaTopBarHidden} {
    display: none;
  }
`;
